import { type FC, type PropsWithChildren, type ReactNode } from 'react'

interface AccountCardShellProps extends PropsWithChildren {
  heading: string
  complete: boolean
  action?: ReactNode
}

export const AccountCardShell: FC<AccountCardShellProps> = ({ heading, complete, action, children }) => (
  <div className='border zocks-border-color-gray-300 rounded-3 p-3 d-flex flex-column zocks-gap-1'>
    <div className='d-flex align-items-center justify-content-between zocks-gap-1'>
      <div className='d-flex align-items-center zocks-gap-0.5'>
        <h5 className='mb-0'>{heading}</h5>
        <i className={complete ? 'bi bi-check-circle zocks-text-success' : 'bi bi-pencil-square'} />
      </div>
      {action}
    </div>
    {children}
  </div>
)
